<template>
  <div class="field-descriptions-overlay" @click.self="onClose">
    <div class="field-descriptions-modal">
      <div class="modal-header">
        <p class="modal-title">แก้ไข Field Descriptions — {{ file.filename }}</p>
        <i class="bx bx-x close-btn" @click="onClose"></i>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label>คำอธิบายภาพรวมของไฟล์ (ไม่บังคับ)</label>
          <textarea v-model="form.filePrompt" rows="4"></textarea>
        </div>
        <div class="fields-section" v-if="form.fieldDescriptions && Object.keys(form.fieldDescriptions).length > 0">
          <p class="fields-label">อธิบายแต่ละ field:</p>
          <div v-for="(value, fieldName) in form.fieldDescriptions" :key="fieldName" class="field-item">
            <p class="field-name">{{ fieldName }}</p>
            <input
              type="text"
              v-model="form.fieldDescriptions[fieldName]"
              :placeholder="`คำอธิบาย field ${fieldName}`"
            />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn-cancel" :disabled="isSaving" @click="onClose">Cancel</button>
        <button class="btn-save" :disabled="isSaving" @click="onSave">{{ isSaving ? 'Saving...' : 'Save' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'field-descriptions-modal',
  props: {
    file: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      default: null,
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        filePrompt: '',
        fieldDescriptions: {},
      },
    };
  },
  created() {
    if (this.data) {
      this.form.filePrompt = this.data.file_prompt || '';
      this.form.fieldDescriptions = this.data.field_descriptions
        ? JSON.parse(JSON.stringify(this.data.field_descriptions))
        : {};
    }
  },
  mounted() {
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    onKeydown(event) {
      if (event.key === 'Escape') {
        this.onClose();
      }
    },
    onClose() {
      if (this.isSaving) return;
      this.$emit('closeModal');
    },
    onSave() {
      if (this.isSaving) return;
      const filePrompt = this.form.filePrompt.trim();
      this.$emit('save', {
        file_prompt: filePrompt.length > 0 ? filePrompt : null,
        field_descriptions: { ...this.form.fieldDescriptions },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.field-descriptions-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 1050;
  padding: 40px 16px;
  overflow-y: auto;
}

.field-descriptions-modal {
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 520px;
  display: flex;
  flex-direction: column;

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px 16px;
    border-bottom: 1px solid #E7E8EE;

    .modal-title {
      font-size: 16px;
      font-weight: 600;
      color: #111B49;
      margin: 0;
    }

    .close-btn {
      font-size: 22px;
      color: #868BA6;
      cursor: pointer;
      &:hover { color: #111B49; }
    }
  }

  .modal-body {
    padding: 20px 24px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-height: 60vh;
    overflow-y: auto;

    .form-group {
      display: flex;
      flex-direction: column;
      gap: 6px;

      label {
        font-size: 13px;
        color: #646A8C;
      }

      textarea {
        border: 1px solid #D1D3E0;
        border-radius: 8px;
        padding: 10px 12px;
        font-size: 14px;
        color: #111B49;
        resize: vertical;
        outline: none;
        &:focus { border-color: #111B49; }
      }
    }

    .fields-section {
      display: flex;
      flex-direction: column;
      gap: 12px;

      .fields-label {
        font-size: 13px;
        color: #646A8C;
        margin: 0;
      }

      .field-item {
        display: flex;
        flex-direction: column;
        gap: 4px;

        .field-name {
          font-size: 14px;
          font-weight: 600;
          color: #111B49;
          margin: 0;
        }

        input {
          border: 1px solid #D1D3E0;
          border-radius: 8px;
          padding: 10px 12px;
          font-size: 14px;
          color: #111B49;
          outline: none;
          &:focus { border-color: #111B49; }
          &::placeholder { color: #B0B5C9; }
        }
      }
    }
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 16px 24px 20px;
    border-top: 1px solid #E7E8EE;

    .btn-cancel {
      padding: 8px 20px;
      border-radius: 8px;
      border: 1px solid #D1D3E0;
      background: #fff;
      color: #3D4B65;
      font-size: 14px;
      cursor: pointer;
      &:hover { background: #F5F5F8; }
      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        &:hover { background: #fff; }
      }
    }

    .btn-save {
      padding: 8px 20px;
      border-radius: 8px;
      border: none;
      background: #111B49;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      &:hover { background: #1e2d6b; }
      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        &:hover { background: #111B49; }
      }
    }
  }
}
</style>
